import type { CuisineTag, PriceBucket } from '@bilmat/shared';
import { useApp } from '../state/store';

type ChipDef = { group: 'price' | 'cuisine'; value: string; label: string };

// Etiketter ordagrant från prototypens filterpanel (references/prototype.html, rad 1158–1171).
const CHIPS: ChipDef[] = [
  { group: 'price', value: 'budget', label: '€ Budget' },
  { group: 'price', value: 'mellan', label: '€€ Mellan' },
  { group: 'price', value: 'dyrare', label: '€€€ Dyrare' },
  { group: 'cuisine', value: 'vegetariskt', label: 'Vegetariskt' },
  { group: 'cuisine', value: 'asiatiskt', label: 'Asiatiskt' },
  { group: 'cuisine', value: 'italienskt', label: 'Italienskt' },
  { group: 'cuisine', value: 'snabbmat', label: 'Snabbmat' },
  { group: 'cuisine', value: 'husmanskost', label: 'Värdshus & krog' },
  { group: 'cuisine', value: 'cafe', label: 'Café & konditori' },
];

export function FilterChips() {
  const filters = useApp((s) => s.filters);
  const setFilters = useApp((s) => s.setFilters);

  const isActive = (c: ChipDef): boolean =>
    c.group === 'price'
      ? filters.price.includes(c.value as PriceBucket)
      : filters.cuisine.includes(c.value as CuisineTag);

  const toggle = (c: ChipDef): void => {
    if (c.group === 'price') {
      const v = c.value as PriceBucket;
      const next = filters.price.includes(v)
        ? filters.price.filter((x) => x !== v)
        : [...filters.price, v];
      setFilters({ ...filters, price: next });
    } else {
      const v = c.value as CuisineTag;
      const next = filters.cuisine.includes(v)
        ? filters.cuisine.filter((x) => x !== v)
        : [...filters.cuisine, v];
      setFilters({ ...filters, cuisine: next });
    }
  };

  return (
    <div className="filter-chips" role="group" aria-label="Filter">
      {CHIPS.map((c) => (
        <button
          key={`${c.group}:${c.value}`}
          type="button"
          className={`filter-chip${isActive(c) ? ' filter-chip--active' : ''}`}
          aria-pressed={isActive(c)}
          onClick={() => toggle(c)}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
